export default __webpack_public_path__ + "static/media/colimg.f306a398.jpg";